import { CompanyBranchData, CompanyBranchTransformerToStructureResponse } from "@/common/types/companyBranches.type";
import { GitFork } from "lucide-react";

export class CompanyBranchesTransformer {
  static structureTransformer() {
    return (companyBranches: CompanyBranchData[]) => {
      const nodes = companyBranches.map((branch) => ({
        id: branch.id,
        data: { ...branch },
        type: 'custom',
        position: {
          x: 0,
          y: 0
        }
      }));

      const edges = companyBranches.filter((branch) => branch.parent_id !== null).map((branch) => ({
        id: `${branch.id}-${branch.parent_id}`,
        source: branch.parent_id,
        target: branch.id
      }));

      return { nodes, edges } as CompanyBranchTransformerToStructureResponse;
    };
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key === 'parent_id') {
          key = 'parent';
        }

        if (key.startsWith('restriction.')) {
          key = key.slice(12);
        }

        if (key.endsWith('.base')) {
          key = '_base';
        }

        return {
          [key]: value.join(', ')
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (companyBranches: CompanyBranchData[]) => {
      return companyBranches.map((companyBranch) => ({
        route: `/company-branches/${companyBranch.id}`,
        items: [
          ['Nome da filial', companyBranch.display_name],
        ]
      }));
    };
  }

  static optionsTransformer() {
    return (companyBranches: CompanyBranchData[]) => {
      return companyBranches.map((companyBranch) => {
        return {
          value: companyBranch.id,
          label: companyBranch.display_name,
          icon: <GitFork strokeWidth={1} size={20} />
        };
      });
    };
  }
}
